const DELAY = 80;

export default ($window, $timeout, $parse, $location) => ({
  restrict: "AC",
  scope: false,
  link($scope, $elem, $attr) {
    if (!$window.MagicZoom) return;
    const baseUrl = $location.url();
    const $magiczoomRefreshed = $parse($attr.magiczoomRefreshed);
    const doRefresh = () => {
      // console.debug("doRefresh", $elem[0]);
      try {
        $magiczoomRefreshed.assign($scope, new Date().getTime());
        $window.MagicZoom.refresh($elem[0]);
      } catch {}
    };
    const refresh = () => {
      // console.debug("refresh", $elem[0]);
      $magiczoomRefreshed.assign($scope, null);
      $window.MagicZoom.stop($elem[0]);
      $timeout(doRefresh, DELAY);
    };
    $scope.$on("$locationChangeStart", (event, next, current) => {
      if (next.indexOf("mz-expanded-view-") >= 0) {
        event.preventDefault();
        console.warn("mz-expanded-view$locationChangeStart", {
          event,
          next,
          current,
          $scope,
          $elem,
          $attr,
        });
      }
    });
    $scope.$on("$destroy", () => {
      // console.debug("MagicZoom$destroy", $elem[0]);
      $window.MagicZoom.stop($elem[0]);
      // console.warn("MagicZoom$stop", $elem[0]);
    });
    // $timeout(() => {
    $elem.addClass("MagicZoom");
    $attr.$observe("refresh", (r) => refresh(r));
    //refresh();
    $attr.$observe("href", (href) => refresh(href));
  },
});
